
import { useEffect } from "react";

export const useErrorHandler = (error: unknown, toast: any) => {
  useEffect(() => {
    if (error) {
      console.error("Erreur lors du chargement des signalements:", error);
      toast({
        title: "Erreur",
        description: "Impossible de charger les signalements. Veuillez réessayer.",
        variant: "destructive",
      });
    }
  }, [error, toast]);
};
